import React, { useEffect, useState } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  CartDetailedIcon,
  ChevronRightArrow,
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
  DynamicButton,
} from "../../../components/common/basic";
import CountdownTimer from "../pulsenchill/components/CountdownTimer";
import { BackButton, FeatureHeader } from "../../../components/common";
import GenericModal from "../../../components/common/genericModal";
import { useLoyalty, useTheme } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import loyaltyService from '../../../services/loyalty'
import loadingGif from "../../../components/images/loader.gif";

const BlackFridayHome = () => {
  const history = useHistory();
  const { selectedLoyaltyData } = useLoyalty();
  const [isLoading, setIsLoading] = useState(false);
  const [isQualified, setIsQualified] = useState(false);
  const [redemptionData, setRedemptionData] = useState()
  const { loyaltyItem, setLoyaltyItem } = useLoyalty();
  const token = JSON.parse(localStorage.getItem("token"));
  const checkStatus = async () => {
    try {
      setIsLoading(true);
      const { isQualified, data } = await loyaltyService.checkBlackFridayQualificationStatus(token);
      setRedemptionData(data);
      setIsQualified(isQualified)
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const goToHome = () => {
    history.push(`/home?token=${token}`);
  };


  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "BlackFridayHome",
        firebase_screen_class: "BlackFridayHome",
      })
    );
    checkStatus();
  }, []);

  const note = [
    `It's a race, fam! Only the first 200 of you awesome pulsers get the hookup on this KFC magic.`,
    `This offer is all about that sweet GHC 10.00 Mashup – the key to unlocking your voucher swag.`,
    `Psst... the lucky 200 will be notified on their surprise KFC voucher. Keep those eyes peeled!`,
    `Once you're in the winner's circle, indicate the nearest MTN office to pick up your voucher – easy peasy.`,
    `Stay glued to this spot for the deets on when you can pickup your surprise voucher`,
  ]
  const { themeContext, theme } = useTheme();
  const canRedeem = false;
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  let buttonText = ''
  if (!isLoading) {
    buttonText = isQualified ? "Redeem" : '';
  }

  const message = isQualified
    ? <StyledText
      style={{ fontFamily: "MTNRegular" }}
      size={12}
    >
      Congratulations! You're a Pulse Black Friday Early Bird Winner! Your Mashup purchase of GHC 10.00 on November 24, 2023, has earned you an exclusive early bird reward and we can't wait for you to enjoy your delicious treat! <br/><br/>To claim your prize, simply click the "Redeem" tab above and choose the nearest MTN Office for dispatch and collection. Please ensure you complete this action by 10:59 P.M on November 28, 2023, to secure your reward. <br/><br />Congratulations once again, and thank you for being a valued Pulse user!</StyledText>
    : <>
      <StyledText
        style={{ fontFamily: "MTNRegular" }}
        size={16}
      >

        Hey Pulse Squad!</StyledText>
      <StyledText
        style={{ fontFamily: "MTNRegular" }}
        size={12}
      >
        Big thanks for joining the Pulse Black Friday hype! Even if you didn't snag the top 200 spots, we're grateful for your awesome support. Don't sweat it—there's a heap of cool deals and promos on the Pulse app just for you! Dive into the other epic offers and stay tuned for more exclusive goodies coming your way! Let's keep the party going!</StyledText>
    </>;


  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => goToHome()} />
          <FeatureHeader
            image={selectedLoyaltyData?.image}
            title={["MTN Pulse", "Black Friday"]}
            buttonText={buttonText}
            onClick={() => {
              history.push("/black-friday/pickup");
              setLoyaltyItem(redemptionData)
            }}
            background={"#fff"}
            secondaryBackground={"#fff"}
          >
          </FeatureHeader>

          <Body>
            {/* <Button onClick={() => history.push('/speedshopping/cataloguehome')}>Shop</Button> */}
            {
              isLoading ? <div style={{ textAlign: "center" }}>
                <img
                  alt={"dialog"}
                  src={loadingGif}
                  style={{ display: "block", width: "40px", margin: "0 auto" }}
                />
                <StyledText>Checking status...</StyledText>
              </div>
                :
                <div style={{ margin: '0 auto', maxWidth: "340px" }}>{message}</div>
            }
          </Body>
          <CurveOverImage
            style={{
              position: "relative",
              zIndex: 1,
              marginTop: -10,
              width: "100%",
            }}
            fill={"white"}
          />
        </Children>
      </MainHolder>
    </>
  );
};

export default BlackFridayHome;
